import React, { useEffect, useState } from 'react';
import { IoIosArrowForward, IoIosArrowDown } from "react-icons/io";
import WebService from '../../Services/WebService';
import { Link, useNavigate } from 'react-router-dom';
import HelperService from '../../Services/HelperService';

const VerticalMenu = React.memo(() => {
    const [list, setList] = useState([]);
    const [URL, setURL] = useState("/manage-dashboard");
    const [openSubMenu, setOpenSubMenu] = useState<number | null>(null);
    const navigate = useNavigate();

    useEffect(() => {
        setURL(window.location.pathname);
    }, [])

    const fetchMenus = () => {
        return WebService.getAPI({
            action: `menus`,
            body: null,
        })
            .then((res: any) => {
                setList(res?.list);
                localStorage.setItem("zioT-menus", JSON.stringify(res.list));
            })
            .catch((error) => {
                console.log(error);

            })
    };

    useEffect(() => {
        const cachedMenus = localStorage.getItem("zioT-menus");
        if (cachedMenus) {
            const parsedMenus = JSON.parse(cachedMenus);
            setList(parsedMenus);

            // Only navigate once after login (not on browser back)
            const hasNavigated = sessionStorage.getItem("hasNavigatedToFirstMenu");
            if (!hasNavigated && parsedMenus.length > 0) {
                navigate(parsedMenus[0].url);
                sessionStorage.setItem("hasNavigatedToFirstMenu", "true");
            }
        } else {
            fetchMenus();
        }
    }, []);


    const handleSelectedMenu = (url: string) => {
        setURL(url);
    }

    const toggleSubMenu = (index: number) => {
        setOpenSubMenu(openSubMenu === index ? null : index);
    }

    return (
        <>
            <div className="layout-veritcle-menu">
                <div id="vertical_menu" className="verticle-menu">
                    <div className="menu-list">
                        {list && list.length > 0 && list?.map((itm: any, index: any) => (
                            <div key={index}>
                                <div
                                    style={{ cursor: "pointer" }}
                                    onClick={() => itm?.childMenus?.length > 0 && toggleSubMenu(index)}
                                >
                                    <Link
                                        to={itm?.url || '/'}
                                        className={URL == itm?.url ? 'menu-item active' : 'menu-item'}
                                        onClick={() => handleSelectedMenu(itm?.url)}
                                    >
                                        <span className="nav-text" style={{ float: "left" }}>{HelperService.removeUnderScore(itm?.menu)}</span>
                                        {itm?.childMenus?.length > 0 && (
                                            <span style={{ float: "right" }}>
                                                {openSubMenu === index ? <IoIosArrowDown /> : <IoIosArrowForward />}
                                            </span>
                                        )}
                                    </Link>
                                </div>

                                {itm?.childMenus?.length > 0 && openSubMenu === index && (
                                    <div className="menu-list">
                                        {itm?.childMenus.map((subMenu: any, subIndex: any) => (
                                            <div key={subIndex}>
                                                <Link
                                                    key={subIndex}
                                                    to={subMenu?.url || '/'}
                                                    className={URL == subMenu?.url ? 'menu-item active' : 'menu-item'}
                                                    onClick={() => handleSelectedMenu(subMenu?.url)}

                                                >
                                                    <span className="nav-text" style={{ float: "left" }}>{HelperService.removeUnderScore(subMenu?.menu ?? "")}</span>
                                                </Link>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div >
        </>
    )
})

export default React.memo(VerticalMenu);


